import { useState } from "react";
import ButtonActionEditor from "./ButtonActionEditor";

export default function ComposeMessageCard({
  message,
  onChange
}) {

  const [local, setLocal] = useState(message);

  function update(field, value) {
    const updated = { ...local, [field]: value };
    setLocal(updated);
    onChange(updated);
  }

  function addButton() {
    const updated = {
      ...local,
      buttons: [
        ...(local.buttons || []),
        {
          id: `btn_${Date.now()}`,
          label: "New Button",
          action: { type: "NEXT_STEP" }
        }
      ]
    };
    setLocal(updated);
    onChange(updated);
  }

  function updateButton(index, btn) {
    const buttons = [...local.buttons];
    buttons[index] = btn;
    update("buttons", buttons);
  }

  return (
    <div style={{
      border: "1px solid #cbd5e1",
      borderRadius: 8,
      padding: 12,
     
      background: "#fff"
    }}>

      <h4>📧 Compose Message</h4>

      {local.subject !== undefined && (
        <input
          placeholder="Subject"
          value={local.subject}
          onChange={e => update("subject", e.target.value)}
          style={{ width: "100%", marginBottom: 8 }}
        />
      )}

      <textarea
        rows={5}
        placeholder="Message body"
        value={local.body}
        onChange={e => update("body", e.target.value)}
        style={{ width: "100%" }}
      />

      <div style={{ marginTop: 10 }}>
        <strong>Buttons</strong>
      </div>

      {local.buttons?.map((btn, i) => (
        <ButtonActionEditor
          key={btn.id}
          button={btn}
          onChange={b => updateButton(i, b)}
        />
      ))}

      <button onClick={addButton} style={{ marginTop: 8 }}>
        ➕ Add Button
      </button>

    </div>
  );
}
